<main class="main-content theme-so">
    <section class="section section-category-header">
        <div class="st-inner">
            <lottie-player src="/assets/img/svg/category/so/2.json" renderer="svg" class="lottie-player" autoplay="true" loop="true">
            </lottie-player>
            <div class="container">
                <div class="st-content">
                    <div class="scroll-container" (window:scroll)="onScroll($event)">
                        <ng-lottie [options]="lottieOptions" width="100%" height="100%"></ng-lottie>
                    </div>

                    <h1 class="page-title h2 split-title">
                        <span class="line-1 f1 mb-0">Ik zoek </span>
                        <span class="line-2 h1 t-lower">speciaal onderwijs</span>
                    </h1>
                    <div class="school-filter type-a clearfix">
                        <div class="c-search clearfix">
                            <input type="text" class="input" name="postcode" [(ngModel)]="zipcode" placeholder="Zoek op postcode" />
                            <a [routerLink]="'/categorie/so/map'" [queryParams]="zipcode ? {'zipcode': zipcode} : {}">zoeken</a>
                        </div>
                        <a [routerLink]="['/', 'categorie', 'so', 'map']" class="match-c-search">
                            <span>Zoeken zonder postcode <i class="icon-right-small"></i></span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section section-category-article">
        <div class="st-inner">
            <lottie-player src="/assets/img/svg/category/so/4.json" renderer="svg" class="lottie-player" autoplay="true" loop="true">
            </lottie-player>
            <div class="container">
                <div class="col-right">
                    <figure class="st-image bgimg" style="background-image: url('/assets/img/photos/SO/SO_01.jpg');">
                        <span class="overlay"></span>
                        <img src="/assets/img/photos/SO/SO_01.jpg" alt="Foto speciaal onderwijs" />
                    </figure>
                </div>

                <div class="col-left indent">
                    <h2 class="h2">{{ pageContent.block_1_title ?? '' }}</h2>
                    <div class="article-output">
                        <div [innerHTML]="pageContent.block_1_body ?? ''"></div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section section-category-text">
        <div class="st-inner">
            <div class="container">
                <div class="row">
                    <div class="col-md-4 col-lg-5"></div>

                    <div class="col-md-7 col-lg-6 c-article-list">
                        <article class="article-item">
                            <h2 class="article-title h2">{{ pageContent.block_2_title ?? '' }}</h2>
                            <div class="article-output">
                                <div [innerHTML]="pageContent.block_2_body ?? ''"></div>
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section section-category-articles">
        <div class="st-inner">
            <div class="container">
                <div class="st-header indent">
                    <h2 class="h2 split-title">
                        <span class="line-1 f1 mb-0">{{ pageContent.block_3_title_line1 ?? '' }}</span>
                        <span class="line-2 h1">{{ pageContent.block_3_title_line2 ?? '' }}</span>
                    </h2>
                </div>

                <app-sub-category-list subCategorySlug="SO"></app-sub-category-list>
            </div>
        </div>
    </section>

    <section class="section section-category-faq" *ngIf="faqs && faqs.length">
        <div class="st-inner">
            <span class="before"></span>
            <div class="container">
                <div class="st-header indent">
                    <h2 class="h2 split-title">
                        <span class="line-1 f1 mb-0">{{ pageContent.block_4_title_line1 ?? '' }}</span>
                        <span class="line-2 h1">{{ pageContent.block_4_title_line2 ?? '' }}</span>
                    </h2>
                </div>

                <div class="col-left indent">
                    <div class="c-faq-links">
                        <a href="{{faq.link}}" class="question" *ngFor="let faq of faqs"
                            >{{faq.question}} <span class="arrow"><i class="icon-right-small"></i></span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>
